<template>
  <div id="leaseagreement" class="depot-statistics">
    <div id="content">
      <div class="justify-content-between flex">
        <div class="col-md-10">
          <h1>Statistieken</h1>
        </div>
        <div class="col-md-2 justify-content-end">
          <select id="depot-select" multiple="multiple">
            <option v-for="depot in depots" :value="depot.id" selected>{{
              depot.name
            }}</option>
          </select>
        </div>
      </div>

      <div class="card widget" v-for="depot in filteredDepots">
        <div class="card-header">
          <h1 class="card-title">{{ depot.name }}</h1>
          <div class="vehicle-data">
            Voertuigen: {{ depot.vehicles_count }} <br />
            Ingezet: {{ depot.driving_vehicles_count }} <br />
            Bezettingsgraad: {{ getDeployedPercentage(depot) }}%
          </div>
        </div>
        <div class="card-body">
          <div
            class="depot-content"
            v-if="depot.is_opened && !depot.is_loading"
          >
            <h2>Ingezette voertuigen</h2>
            <div v-for="vehicle in depot.driving_vehicles">
              <span
                >{{ vehicle.license_plate }} - Segment
                {{ vehicle.segment.name }}</span
              >
              <br />
            </div>
            <br />
            <h2>Beschikbare voertuigen</h2>
            <div v-for="vehicle in depot.available_vehicles">
              <span
                >{{ vehicle.license_plate }} - Segment
                {{ vehicle.segment.name }}</span
              >
              <br />
            </div>
          </div>
          <div class="extend text-center">
            <img
              src="/frontend/img/loading-spinner.svg"
              class="loading-icon"
              v-if="depot.is_loading"
            />
            <i
              v-if="!depot.is_loading"
              :class="depot.is_opened ? 'fa-chevron-up' : 'fa-chevron-down'"
              class="fa pointer"
              @click="onDepotClick(depot)"
            ></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import whenMultiselectReady from "@/helpers/whenMultiselectReady";

export default {
  name: "return-locations-depot-list",
  data() {
    return {
      depots: this.$route.params.depots,
      filteredDepots: this.$route.params.depots
    };
  },
  mounted() {
    whenMultiselectReady(() => {
      $("#depot-select").multiselect({
        enableFiltering: true,
        filterBehavior: "text",
        maxHeight: 200,
        includeSelectAllOption: true,
        onChange: this.selectChanged,
        onSelectAll: this.selectChanged,
        onDeselectAll: this.selectChanged
      });
    });
  },
  methods: {
    onDepotClick(depot) {
      this.getVehicleData(depot);
      depot.is_opened = !depot.is_opened;
      this.$forceUpdate();
    },
    getVehicleData(depot) {
      if (depot?.driving_vehicles) return;
      depot.is_loading = true;
      axios.get(`${env.API_URL}/depots/${depot.id}/vehicle-data`).then(res => {
        depot.driving_vehicles = res.data.driving_vehicles;
        depot.available_vehicles = res.data.available_vehicles;
        depot.is_loading = false;
        this.$forceUpdate();
      });
    },
    getDeployedPercentage(depot) {
      return (
        (depot.driving_vehicles_count / depot.vehicles_count) *
        100
      ).toFixed(2);
    },
    selectChanged() {
      const selectedOptions = $("#depot-select").val();
      this.filteredDepots = this.depots.filter(depot =>
        selectedOptions.includes(depot.id.toString())
      );
    }
  }
};
</script>
